import { DocumentNode, gql } from '@apollo/client'

export const GET_DAYCARE_MEAL_MENUS: DocumentNode = gql`
    query GetDaycareMealMenus($daycareId: Int!) {
        getDaycareMealMenus(daycareId: $daycareId) {
            id
            daycareId
            menu
        }
    }
`

export const GET_DAYCARE_MEAL_HABITS: DocumentNode = gql`
    query GetDaycareMealHabits($daycareId: Int!) {
        getDaycareMealHabits(daycareId: $daycareId) {
            id
            daycareId
            habit
        }
    }
`

export const GET_DAYCARE_MEAL_TEXTURES: DocumentNode = gql`
    query GetDaycareMealTextures($daycareId: Int!) {
        getDaycareMealTextures(daycareId: $daycareId) {
            id
            daycareId
            texture
        }
    }
`

export const GET_DAYCARE_MEAL_ACCESSIBILITY_SECTION: DocumentNode = gql`
    query GetDaycareMealAccessibility($daycareId: Int!) {
        getDaycareMealAccessibility(daycareId: $daycareId) {
            id
            daycareId
            sectionId
            sectionName
            start
            type
        }
    }
`

export const GET_DAYCARE_CHILD_MEAL: DocumentNode = gql`
    query GetDaycareChildMeal($daycareId: Int!, $childId: Int!) {
        getDaycareChildMeal(daycareId: $daycareId, childId: $childId) {
            childId
            mealMenus {
                id
                daycareId
                menu
            }
            mealTextures {
                id
                daycareId
                texture
            }
            mealHabits {
                id
                daycareId
                habit
            }
        }
    }
`

export const GET_MEAL_DETAIL_BY_TYPE: DocumentNode = gql`
    query GetMealDetailByType($daycareId: Int!, $sectionIds: [Int]!, $date: Date!, $mealTypes: [MealType]) {
        getMealDetailByType(daycareId: $daycareId, sectionIds: $sectionIds, date: $date, mealTypes: $mealTypes) {
            date
            closingDay
            typeDetails {
                type
                sectionId
                sectionName
                frozen
                frozenDate
                details {
                    quantityAdded
                    quantityReserved {
                        childId
                        firstname
                    }
                    quantityReal {
                        childId
                        firstname
                    }
                    combination {
                        menus {
                            id
                            daycareId
                            menu
                        }
                        textures {
                            id
                            daycareId
                            texture
                        }
                        habits {
                            id
                            daycareId
                            habit
                        }
                    }
                }
                childs {
                    childId
                    firstname
                    complement
                    sectionId
                    sectionName
                    start
                    end
                    slotType
                    menus {
                        id
                        daycareId
                        menu
                    }
                    textures {
                        id
                        daycareId
                        texture
                    }
                    habits {
                        id
                        daycareId
                        habit
                    }
                }
                childsWithoutMenu {
                    childId
                    firstname
                    complement
                    sectionId
                    sectionName
                    start
                    end
                    slotType
                }
            }
        }
    }
`
